import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import style from './PrimeToggle.module.scss'

const PrimeToggle = () => (
  <div className={style.Prime}>
    <EmptyLink>
      <div className={style.PrimeIcon}></div>
    </EmptyLink>
    <div className={style.PrimeSwitch}>
      <EmptyLink>
        <div className={style.toggler}>
          <div className={style.togglerSign}></div>
        </div>
      </EmptyLink>
    </div>
  </div>
)

export default PrimeToggle
